import React from "react"
import {MovieProvider} from "../Context/MovieContext"
import Movie from "./Movies"


const Movies = () =>{

  return(
    <MovieProvider>
      <Movie/>
    </MovieProvider>
  )
}

export default Movies